import api from './axios';

/** Companies to contact, ordered by how soon their event is.
 *  `withinDays` is the "next week / month / year" window; `upcomingOnly` hides leads whose
 *  event has already passed. */
export const listAdminLeads = (
  page = 0,
  size = 20,
  { status, withinDays, city, past = false, unassignedOnly, assignee } = {}
) =>
  api.get('/admin/leads', {
    params: {
      page,
      size,
      status: status || undefined,
      withinDays: withinDays || undefined,
      city: city || undefined,
      // past=true looks BACKWARD over the same span and sorts most-recent-first.
      past,
      unassignedOnly: unassignedOnly || undefined,
      assignee: assignee || undefined,
    },
  });

export const updateLeadStatus = (id, status) => api.patch(`/admin/leads/${id}/status`, { status });

/** Claim, reassign, or release a lead. Pass a null/blank email to unassign.
 *  Assignment survives the nightly scraper run — the upsert never touches these fields. */
export const assignLead = (id, email, displayName) =>
  api.patch(`/admin/leads/${id}/assignee`, { email: email || '', displayName: displayName || '' });

/** GCC announcements, newest first.
 *  NOTE: `withinDays` runs BACKWARD here — "announced in the last N days" — the opposite
 *  of every other use of that param in this file. The UI relabels the control accordingly
 *  when this tab is active; don't reuse this function behind a "next N days" label. */
export const listAdminAnnouncements = (
  page = 0,
  size = 20,
  { status, withinDays, city, unassignedOnly, assignee } = {}
) =>
  api.get('/admin/leads/announcements', {
    params: {
      page,
      size,
      status: status || undefined,
      withinDays: withinDays || undefined,
      city: city || undefined,
      unassignedOnly: unassignedOnly || undefined,
      assignee: assignee || undefined,
    },
  });

/** Upcoming events only — the backend always bounds these to today onward. */
export const listAdminEvents = (page = 0, size = 20, { withinDays, city, sector } = {}) =>
  api.get('/admin/events', {
    params: {
      page,
      size,
      withinDays: withinDays || undefined,
      city: city || undefined,
      sector: sector || undefined,
    },
  });

/** Count of rows left behind by the retired hiring/R&R/GCC/expo-directory scrapers. */
export const getRetiredLeadCount = () => api.get('/admin/leads/retired-count');

export const purgeRetiredLeads = () => api.delete('/admin/leads/retired');
